package org.lennycodes.hldi.styles

import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.css.TextDecorationLine
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.css.TransitionTimingFunction
import com.varabyte.kobweb.compose.css.functions.LinearGradient
import com.varabyte.kobweb.compose.css.functions.linearGradient
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.backgroundImage
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.bottom
import com.varabyte.kobweb.compose.ui.modifiers.boxShadow
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.textAlign
import com.varabyte.kobweb.compose.ui.modifiers.textDecorationLine
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.selectors.focusVisible
import com.varabyte.kobweb.silk.style.selectors.hover
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.s
import org.lennycodes.hldi.constants.HLDITheme
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.modifiers.display
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.styleModifier
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.percent

// ── Shared styles ──────────────────────────────────────────

val contactHeroStyle = CssStyle {
    base {
        Modifier
            .backgroundColor(HLDITheme.Colors.primary)
            .color(HLDITheme.Colors.white)
            .textAlign(TextAlign.Center)
            .backgroundImage(
                linearGradient(
                    HLDITheme.Colors.primary,
                    HLDITheme.Colors.secondary,
                    LinearGradient.Direction.ToBottomRight
                )
            )
    }
    Breakpoint.MD {
        Modifier.padding(topBottom = 100.px, leftRight = 20.px)
    }
}

val contactHeroTitleStyle = CssStyle {
    base {
        Modifier
            .fontSize(32.px)
            .fontFamily("Playfair Display", "serif")
            .margin(bottom = 16.px)
    }
    Breakpoint.MD {
        Modifier.fontSize(48.px)
    }
}

val contactInfoCardStyle = CssStyle {
    base {
        Modifier
            .backgroundColor(HLDITheme.Colors.white)
            .borderRadius(12.px)
            .boxShadow(
                offsetX = 0.px, offsetY = 2.px, blurRadius = 8.px,
                color = Color.rgba(0, 0, 0, 0.08f)
            )
    }
}

val socialLinkStyle = CssStyle {
    base {
        Modifier
            .backgroundColor(HLDITheme.Colors.accent)
            .color(HLDITheme.Colors.primary)
            .borderRadius(8.px)
            .textDecorationLine(TextDecorationLine.None)
            .fontSize(14.px)
            .fontWeight(500)
            .transition(Transition.all(duration = 0.3.s, timingFunction = TransitionTimingFunction.Ease))
    }
    hover {
        Modifier
            .backgroundColor(HLDITheme.Colors.primary)
            .color(HLDITheme.Colors.white)
    }
    focusVisible {
        Modifier.boxShadow(spreadRadius = 2.px, color = HLDITheme.Colors.accent)
    }
}

val SocialLinksRowStyle = CssStyle {
    base {
        Modifier
            .display(DisplayStyle.Flex)
            .gap(16.px)
            .styleModifier { property("flex-wrap", "wrap") }
    }
}

val SocialIconButtonStyle = CssStyle {
    base {
        Modifier
            .display(DisplayStyle.Flex)
            .styleModifier {
                property("align-items", "center")
                property("justify-content", "center")
            }
            .width(44.px)
            .height(44.px)
            .borderRadius(50.percent)
            .backgroundColor(HLDITheme.Colors.white)
            .color(HLDITheme.Colors.primary)
            .fontSize(18.px)
            .styleModifier {
                property("text-decoration", "none")
                property("box-shadow", "0 2px 8px ${Color.rgba(0, 0, 0, 0.12f)}")
                property("transition", "background-color 250ms ease, color 250ms ease, transform 250ms ease")
            }
    }
    hover {
        Modifier.styleModifier {
            property("background-color", "${HLDITheme.Colors.primary}")
            property("color", "${HLDITheme.Colors.white}")
            property("transform", "translateY(-3px)")
        }
    }
}